import React from 'react'
import { CardFrame } from '../../../ui/CardFrame/CardFrame.jsx'
import { KudosList } from '../interactions/KudosList.jsx'

/**
 * KudosCard — people rows with relationship tag (peer/cross-team/external).
 * catalog #10, prep-kudos. Reuses KudosList (already has relationship cycling).
 */
export function KudosCard({ card, value, onChange, disabled }) {
  const items = value?.items ?? []
  const hasBullets = items.some((i) => i.name || i.description)

  return (
    <CardFrame
      kind="prep"
      icon="✦"
      iconClass="berry"
      title="Kudos"
      prompt="Who deserves a shout-out?"
      state={disabled ? 'locked' : hasBullets ? 'filled' : 'empty'}
      data-testid="prep-card-prep-kudos"
      className="prepcard"
    >
      <KudosList
        value={value}
        onChange={onChange}
        maxItems={2}
        disabled={disabled}
      />
    </CardFrame>
  )
}
